// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1eE6-","label":"Completed_label__2uoVb"};